import config from '@/config/config.js'
import { getStore } from '@/utils/utils.js'
let ws = null
const wsm = {
  state: {
    //webSocket对象
    wsLink: {}

  },
  getters: {
    //获取webSocket对象
    getWSLink(state) {
      let wsLink = state.wsLink;
      return wsLink
    }
  },
  mutations: {
    CACHE_WSLINK(state, value) {
      state.wsLink = value;
    }
  },
  actions: {
    //存储webSocket对象
    cacheWSLink({
      commit
    }, value) {
      setTimeout(() => {
        commit('CACHE_WSLINK', value)
      }, 100)
    },
    //初始化webSocket对象
    initWSLink({
      commit
    }, value) {
      initWS(value).then(res => {
        setTimeout(() => {
          commit('CACHE_WSLINK', res)
        }, 100)
      }) 
      return ws
    }
  }
}
/**
 * 初始化socket
 * @param {入参} value 
 */
const initWS = (value) => {
  return new Promise((resolve, reject) => {
    let flk = getStore('flk')
    ws = new WebSocket(`wss://${config.hostName}/scavengerIm/joinRoom/${value.currentRoomId}?JWTToken=${flk}&appName=${config.appName}`)
    ws.onopen = (evt) => {
      console.log('^^^^', value)
      joinRoom(value.currentRoomId)
      let heartbeatFun = setInterval(heartbeat, 10000);
      let wsInfo = {
        wsLink: ws,
        currentRoomId: value.currentRoomId,
        heartbeatFun
      }
      resolve(wsInfo)
    }
  })
}
const joinRoom = (roomId) => {
  let data = {
    roomId
  };
  let msgdata = {};
  msgdata.event = "JOIN_ROOM";
  msgdata.data = data;
  ws.send(JSON.stringify(msgdata))
}

const heartbeat = () => {
  ws.send(JSON.stringify({
    event: 'HEARTBEAT'
  }))
}


export default wsm;